module.exports = __webpack_public_path__ + "static/img/item10.5c26632.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/item10.png
// module id = Ibu2
// module chunks = 0